import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, tap, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class UsersService {

  private strUserID: string = '1';
  private ComServiceSecureData: any;
  private apiUrl = environment.apiUrl + 'api/documents/';

  constructor(private _http: HttpClient) {
    this.ComServiceSecureData = localStorage.getItem('security-token') == null ? '' : JSON.parse(localStorage.getItem('security-token'));
  }

  //THIS IS SERVICE AUTHENCATE USER DETAILS BY MOBILE NUMBER
  UserAuthencations(data: any): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/user/checkuserauth', data, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      catchError(this.handleError)
    );
  }

  CheckUserByMobile(strMobile: string): Observable<any> {
    const searchHistory = localStorage.getItem('searchHistory') || ''; // Retrieve search history from local storage

    const requestBody = {
      mobile: strMobile,
      searchHistory: searchHistory
    };

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    //console.log(requestBody);

    return this._http.post(environment.apiUrl + 'api/user/checkbymobile', requestBody, httpOptions).pipe(
      tap(null, () => {
        // An error has occurred, so increment this request's ERROR_COUNT.
      }),
      catchError(this.handleError)
    );
  }


  //THIS IS SERVICE AUTHENCATE USER DETAILS BY MOBILE NUMBER
  UserAdminAuthencations(data: any): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/admin/checkadminuserauth', data, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      catchError(this.handleError)
    );
  }

  // GenerateLoginOTP(strMobile: string): Observable<any> {
  //   var httpOptions = {
  //     headers: new HttpHeaders({
  //       "Content-Type": "application/json"
  //     })
  //   };

  //   return this._http.post(environment.apiUrl + 'api/user/sendotpmobile?mobile=' + strMobile + '', null, httpOptions).pipe(
  //     tap(null,
  //       () => {
  //         // An error has occurred, so increment this request's ERROR_COUNT.
  //       }),
  //     catchError(this.handleError)
  //   );
  // }

  //THIS IS SERVICE CALL FOR ADD OR UPDATE CUSTOMER DETAILS 
  SaveUserData(data: any): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/user/addupdatecustomer', data, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE CALL FOR ADD AGENT DETAILS 
  SaveAgentData(data: any): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/user/addagent', data, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE CALL FOR GET USER PROFILE DETAILS 
  GetUserProfile(data: any, typeId: number): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/user/getuserprofile?UserID=' + data + '&UserType=' + typeId + '', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE CALL FOR UPDATE USER PROFILE DETAILS 
  UpdateUserProfile(data: any): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/user/updateuserprofile/', data, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE UPLOAD IMAGE
  UploadImage(e: any, uploadType: string): Observable<any> {
    return this._http.post<any>(environment.apiUrl + 'api/documents/PostFile/' + uploadType + '/', e).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE UPLOAD IMAGE
  UploadImageFile(e: any, option: string, filetype: string, reqID: number): Observable<any> {
    return this._http.post<any>(environment.apiUrl + 'api/documents/UploadPostFile/' + option + '/' + filetype + '/' + reqID + '/', e).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE UPLOAD IMAGE
  SaveAgentDetails(e: any): Observable<any> {
    return this._http.post<any>(environment.apiUrl + 'api/admin/updateagentinfo/', e).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE CALL FOR GET USER PROFILE DETAILS 
  SaveUserProfile(data: any): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/user/uploaduserprofile/', data, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE CALL FOR UPDATE USER PROFILE DETAILS 
  SaveUserPassword(_uID: any, _Pass: any): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/user/changeuserpassword?UserID=' + _uID + '&password=' + _Pass.trim() + '', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE CALL FOR GET USER PROFILE DETAILS 
  GetAgentProfile(data: any): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/user/getagentprofilebycode?UserID=' + data + '', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE CALL FOR ADD AGENT DETAILS 
  SaveBuilderData(data: any): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/builder/addupdatebuilderdetails', data, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE CALL FOR ADD AGENT DETAILS 
  SaveServiceProviderData(data: any): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/user/addupdateprovider/', data, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE CALL FOR GET USER PROFILE DETAILS 
  GetAllBusinessCategory(cid: number, pid: string): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/user/getbusinesscategorylist?catId=' + cid + '&parentId=' + pid + '', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE CALL FOR GET USER PROFILE DETAILS 
  GetBusinessPartners(cid: number, uid: number): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/user/getpartnerslistbycategory?catId=' + cid + '&userId=' + uid + '', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      catchError(this.handleError)
    );
  }

  deleteFile(fileName: string): Observable<any> {
    const url = `${environment.apiUrl}api/documents/DeleteFile/${fileName}/`;
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(url, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      catchError(this.handleError)
    );

  }

  // Method to get top properties info with optional searchHistory
  StoreUserSearchHistory(reqBody: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    // Make sure there is no trailing slash at the end of the URL
    const url = `${environment.apiUrl}api/properties/insertpropertysearch`;
    return this._http.post(url, reqBody, httpOptions).pipe(
      tap(response => {
        // Handle successful response here if needed
      }),
      retry(2), // Retry the request a configurable number of times
      catchError(this.handleError)
    );
  }

  // Method to get top properties info with optional searchHistory
  SaveClickToCall(reqBody: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    // Make sure there is no trailing slash at the end of the URL
    const url = `${environment.apiUrl}api/user/interaction`;
    return this._http.post(url, reqBody, httpOptions).pipe(
      tap(response => {
        // Handle successful response here if needed
      }),
      retry(2), // Retry the request a configurable number of times
      catchError(this.handleError)
    );
  }

  SaveGetAppointment(data: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };
    return this._http.post(environment.apiUrl + 'api/user/interaction', data, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      catchError(this.handleError)
    );
  }

  // In your service, handle both response formats
  SaveSnapShare(data: any): Observable<any> {
    return this._http.post(environment.apiUrl + 'api/user/snapshare', data).pipe(
      map((response: any) => {
        // Handle both response formats
        if (response.status !== undefined) {
          return response; // {status: 1, message: "...", body: {...}}
        } else if (response.Message !== undefined) {
          return { status: 1, message: response.Message, body: response };
        }
        return response;
      }),
      catchError(this.handleError)
    );
  }


  private handleError(error: HttpErrorResponse) {
    if (error.status >= 400) {
      this.clearCache();
    }

    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }

    // Return an observable with a user-facing error message.
    return throwError(error);
  }

  private clearCache() {
    localStorage.clear();
    //console.log('Cache cleared due to error.');
  }

  //THIS IS THE FUNCATION FOR CONVERT TO LOCAL(YYYY-MM-DD) DATE FORMAT BY GIVEN DATE FORMAT
  private ConvertToDate(strD: any): string {
    return new Date(new Date(strD).getFullYear(), new Date(strD).getMonth(), ((new Date(strD).getDate()) + 1)).toISOString().slice(0, 10);
  }


  getReferralUsers(userId?: number): Observable<any> {
    let url = environment.apiUrl + 'api/user/GetReferralUsers';

    // If userId is provided, add it as query parameter
    if (userId) {
      url += `?userId=${userId}`;
    }

    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.get(url, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      catchError(this.handleError)
    );
  }



 getAreaManagingPartners(): Observable<any> {
    const url = environment.apiUrl + 'api/user/GetAMPWithAssignedUsers';
    const httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };
    return this._http.get(url, httpOptions).pipe(
        tap(() => {}),
        catchError(this.handleError)
    );
}


}
